/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorRunTriggerEnum {
  Cron = 'cron',
  Manual = 'manual',
  Webhook = 'webhook'
}
